<ng-container *ngIf="contentBlocks.length > 0">
  <div *ngFor="let contentBlock of contentBlocks; let index = index" [class.mv-2]="index > 0">
    <ng-container [ngSwitch]="contentBlock.type">
      <app-ticker-block
        *ngSwitchCase="'ticker'"
        [tickerBlock]="contentBlock">
      </app-ticker-block>
      
      <app-markdown-block
        *ngSwitchCase="'markdown'" 
        [markdownBlock]="contentBlock"
        [layout]="layout">
      </app-markdown-block>

      <app-images-block
        *ngSwitchCase="'images'"
        [imagesBlock]="contentBlock"
        [layout]="layout">
      </app-images-block>
    </ng-container>
  </div>
</ng-container>